import { CTALink } from '@ovotech/nebula';
import React from 'react';
import imageV2 from '@/src/resources/offers/ovoChargeAnytimeOffer2.png';
import { PtzOffer } from '../PtzOffer';

export const Anytime = () => {
  const route = '/anytime/eligibility';

  return (
    <PtzOffer
      imagePath={imageV2}
      title="Charge Anytime Monthly"
      description="Get miles more for your money with our smart charging plans. Choose
          from home and public options and a great range of perks."
    >
      <CTALink
        href={route}
        iconRight="off"
        variant="secondary"
        fullWidth={true}
      >
        Check it out
      </CTALink>
    </PtzOffer>
  );
};
